var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * A treatment plan the patient may NOT self-book, rendered as a non-clickable
 * "please contact the practice" card. Either a multi-Heilmittel plan with no
 * confirmed appointment history to mirror the Kombi grouping from (PRD #1343,
 * RS-006): the practice books the first session, after which the plan becomes
 * bookable. Or a video plan for a patient without a Contact address.
 */
export class PatientContactPracticePlanDto {
    treatmentPlanId;
    /** The plan's Heilmittel names joined (e.g. "Krankengymnastik + Manuelle Therapie"). */
    treatmentLabel;
    reason;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientContactPracticePlanDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientContactPracticePlanDto.prototype, "treatmentLabel", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientContactPracticePlanDto.prototype, "reason", void 0);
//# sourceMappingURL=patient-contact-practice-plan.dto.js.map